import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { googleSession } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

// Handles the Emergent Google-auth return: {origin}/chat#session_id=...
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { loginAs } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    const target = location.pathname && location.pathname !== "/" ? location.pathname : "/chat";
    if (!sessionId) {
      navigate("/auth", { replace: true });
      return;
    }
    googleSession(sessionId)
      .then((res) => {
        loginAs(res.data.access_token, res.data.user);
        window.history.replaceState(null, "", target);
        navigate(target, { replace: true, state: { user: res.data.user } });
      })
      .catch((e) => {
        toast.error(e?.response?.data?.detail || "Google sign-in failed. Please try again.");
        window.history.replaceState(null, "", "/auth");
        navigate("/auth", { replace: true });
      });
  }, [location.hash, location.pathname, loginAs, navigate]);

  return (
    <div className="grid min-h-screen place-items-center bg-background text-foreground" data-testid="auth-callback">
      <div className="flex items-center gap-3 text-sm text-muted-foreground">
        <Loader2 className="h-4 w-4 animate-spin" /> Signing you in with Google…
      </div>
    </div>
  );
}
